var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 10.668L10.6693 7.33464H8.66927V2.66797H7.33594V7.33464H5.33594L8.0026 10.668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 11.9987H2.66927V7.33203H1.33594V11.9987C1.33594 12.734 1.93394 13.332 2.66927 13.332H13.3359C14.0713 13.332 14.6693 12.734 14.6693 11.9987V7.33203H13.3359V11.9987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrDownload);
export default __webpack_public_path__ + "static/media/br-download.5317ad36cea2861c121fea9054544ae2.svg";
export { ForwardRef as ReactComponent };